import { Http } from "../axios/interceptors";

export const allProfiles = async (param) =>
  Http("GET", `/Profiles/GetList?`, param);

export const getProfile = async (guid) =>
  Http("GET", `/Profiles/Get?guidProfile=${guid}`);

export const createOrEditProfile = async (body, id = null) =>
  id
    ? Http("PUT", `/Profiles/Update`, null, body)
    : Http("POST", "/Profiles/Create", null, body);

export const deleteProfile = async (guid) =>
  Http("DELETE", `/Profiles/Delete?guidProfile=${guid}`);
